import React, { useEffect, useMemo, useRef } from 'react';
import { buildCountdownInnerHtml, paintCountdown } from '../constants/countdownWidget';

/**
 * Palco do contador. O relógio anda aqui; a visualização e o Moodle usam o script do HTML.
 */
export default function RenderCountdown({ content = {}, widgetId }) {
  const ref = useRef(null);
  const contentKey = JSON.stringify(content || {});
  const html = useMemo(
    () => buildCountdownInnerHtml(content, widgetId, { stage: true }),
    [contentKey, widgetId]
  );

  useEffect(() => {
    const root = ref.current?.querySelector('.madri-cd');
    if (!root) return undefined;
    const tick = () => paintCountdown(root, Date.now());
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [html]);

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
}
